import LecturesPage from './LecturesPage';

export default LecturesPage;
